import React from 'react';
import { TableNormalStyled } from './styled';
import cx from 'classnames';
import { Displays } from 'components';

// Renders a body cell and shows a custom tooltip (instant, no native delay)
// only when its content is actually truncated (overflowing).
const BodyCell = ({ style, tooltip, children }) => {
  const ref = React.useRef(null);
  const [isTruncated, setIsTruncated] = React.useState(false);
  const [tipPos, setTipPos] = React.useState(null);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const inner = el.firstElementChild;
    setIsTruncated(
      el.scrollWidth > el.clientWidth ||
        (!!inner && inner.scrollWidth > inner.clientWidth)
    );
  });

  const handleEnter = () => {
    if (!isTruncated || tooltip == null || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setTipPos({ left: r.left, top: r.bottom });
  };
  const handleLeave = () => setTipPos(null);

  return (
    <div
      ref={ref}
      className="body_col"
      style={style}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {children}
      {tipPos && (
        <div
          className="cell_tooltip"
          style={{ left: tipPos.left, top: tipPos.top + 4 }}
        >
          {tooltip}
        </div>
      )}
    </div>
  );
};

export const TableNormal = ({
  theme_standard_table_small,
  theme_standard_table_normal,
  columns,
  data,
  pagination,
  // isShowTopPagination,
  titleTable,
  tableHeight,
  bodyHeight,
  useNo,
  isLoading,
  bgColor,
  bgHeader,
  showPagination,
  paddingTopPagi,
  marginBottomPagination,
  handlePageClick,
  lableBottom,
  // labelEmpty,
  onClickRow,
  limit,
}) => {
  const getRowNumber = (i) => {
    if (pagination?.from != null) return pagination.from + i;
    if (pagination?.current_page != null) {
      const pageSize = pagination?.limit ?? limit ?? 10;
      return (pagination.current_page - 1) * pageSize + i + 1;
    }
    return i + 1;
  };
  const customClass = cx({
    theme_standard_table_small: theme_standard_table_small,
    theme_standard_table_normal: theme_standard_table_normal,
  });

  const getDescendantProp = (obj, desc) => {
    var arr = desc.split('.');
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
  };

  return (
    <TableNormalStyled
      bgHeader={bgHeader}
      paddingTopPagi={paddingTopPagi}
      marginBottomPagination={marginBottomPagination}
      tableHeight={tableHeight}
      bodyHeight={bodyHeight}
    >
      <div className={customClass}>
        <div className="table_container">
          {
            titleTable &&
            <div className='title_table'>
              {titleTable}
            </div>
          }
          <div className="table_scroll">
            <div className="table_header" style={{ background: bgColor }}>
              <div className="header_row">
                {columns &&
                  columns.map((e, i) => (
                    <div key={i} className="header_col" style={e.headerStyle}>
                      {e.renderTitle ? e.renderTitle : e.title}
                    </div>
                  ))}
              </div>
            </div>
            <div className="table_body">
              {isLoading ? (
                <div className='display_loading'>
                  <Displays.SkeletonLoad
                    theme_skeleton_normal
                    height='100%'
                  />
                </div>
              ) : !data || data.length === 0 ? (
                <div className="label_empty">No data</div>
              ) : (
                data.map((e, i) => {
                  return (
                    <div key={i} className="body_row_wrap">
                      <div
                        className="body_row"
                        style={e.rowSty ? e.rowSty : {}}
                        onClick={() => {
                          onClickRow && onClickRow(e);
                        }}
                      >
                        {columns.map((e1, i2) => {
                          const cellValue = getDescendantProp(e, e1.field);
                          const titleText =
                            typeof cellValue === 'string' ||
                            typeof cellValue === 'number'
                              ? String(cellValue)
                              : undefined;
                          return (
                            <BodyCell
                              key={i2}
                              style={e1.style}
                              tooltip={useNo && i2 === 0 ? undefined : titleText}
                            >
                              {useNo && i2 === 0 ? (
                                <div className="no">
                                  {e1.render
                                    ? e1.render({
                                      origin: e,
                                      value: getRowNumber(i),
                                    })
                                    : getRowNumber(i)}
                                </div>
                              ) : e1.render ? (
                                e1.render({
                                  origin: e,
                                  value: cellValue,
                                })
                              ) : (
                                cellValue
                              )}
                            </BodyCell>
                          );
                        })}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
          {showPagination && pagination && data && data.length > 0 && (
            <div className="pagi_layout">
              <div className='lable_total'>
                {lableBottom && lableBottom}
              </div>
              <Displays.PaginationCustom
                theme_standard_pagination
                totalPages={pagination?.last_page}
                currentPageData={pagination?.current_page - 1}
                _handlePageClick={handlePageClick}
              />
            </div>
          )}
        </div>
      </div>
    </TableNormalStyled>
  );
};

export default TableNormal;
